import React from 'react'
import {Link} from 'react-router-dom'
import im3 from'../images/logo.png'
export default function Nav  () {
    return (
            <div className='cont'>
            <nav className='navbar'>
             <div className='containe'>
                 <div className='navbar-container'>
              <ul className='navbar-left'>
                  <div className='navbar-left-log'>
                  <img src={im3} alt="" />                  </div>
              </ul>
              <ul className='navbar-right'>
              <li>    <a href='#home'> Home</a></li>
              <li> <a href='#service'>  Service</a></li>
              <li> <a href='#abou'>   About</a></li>
               
                     
              <li >  <a href='#price'>  Blog</a></li>
              <li > <a href='#contac'>Contact</a></li>
              </ul>
              </div>
             </div>
            </nav>
            </div>
    )
}
